module.exports = __webpack_public_path__ + "img/18.c4277b20.webp";